import {
  HashRouter as Router,
  Route,
  withRouter,
  Switch,
  Redirect,
} from 'react-router-dom';
import Home from './components/home/Home';
import Login from './components/pages/Login';
import Register from './components/pages/Register';
import OtpVerification from './components/pages/OtpVerification';
import GoogleCallback from './components/pages/GoogleCallback';
import AirConditioningBanner from './components/pages/sp/airConditioning/AirConditioningBanner';
import AirConditioningBusiness from './components/pages/sp/airConditioning/AirConditioningBusiness';
import AirConditioningBusinessPackages from './components/pages/sp/airConditioning/AirConditioningBusinessPackages';
import AirConditioningServices from './components/pages/sp/airConditioning/AirConditioningServices';
import AirConditioningWorkingHours from './components/pages/sp/airConditioning/AirConditioningWorkingHours';
import CarDealersBanner from './components/pages/sp/carDealers/CarDealersBanner';
import CarDealersBusiness from './components/pages/sp/carDealers/CarDealersBusiness';
import CarDealersBusinessPackages from './components/pages/sp/carDealers/CarDealersBusinessPackages';
import CarDealersCars from './components/pages/sp/carDealers/CarDealersCars';
import CarDealersCarsPost from './components/pages/sp/carDealers/CarDealersCarsPost';
import CarDealersWorkingHours from './components/pages/sp/carDealers/CarDealersWorkingHours';
import CarInsuranceBanner from './components/pages/sp/carInsurance/CarInsuranceBanner';
import CarInsuranceBusiness from './components/pages/sp/carInsurance/CarInsuranceBusiness';
import CarInsuranceBusinessPackages from './components/pages/sp/carInsurance/CarInsuranceBusinessPackages';
import CarInsurancePackages from './components/pages/sp/carInsurance/CarInsurancePackages';
import CarInsuranceWorkingHours from './components/pages/sp/carInsurance/CarInsuranceWorkingHours';
import CarProtectionBanner from './components/pages/sp/carProtection/CarProtectionBanner';
import CarProtectionBusiness from './components/pages/sp/carProtection/CarProtectionBusiness';
import CarProtectionBusinessPackages from './components/pages/sp/carProtection/CarProtectionBusinessPackages';
import CarProtectionPackages from './components/pages/sp/carProtection/CarProtectionPackages';
import CarProtectionWorkingHours from './components/pages/sp/carProtection/CarProtectionWorkingHours';
import CarWashBanner from './components/pages/sp/carWash/CarWashBanner';
import CarWashBusiness from './components/pages/sp/carWash/CarWashBusiness';
import CarWashBusinessPackages from './components/pages/sp/carWash/CarWashBusinessPackages';
import CarWashPackages from './components/pages/sp/carWash/CarWashPackages';
import CarWashWorkingHours from './components/pages/sp/carWash/CarWashWorkingHours';
import DrivingSchoolBanner from './components/pages/sp/drivingSchool/DrivingSchoolBanner';
import DrivingSchoolBusiness from './components/pages/sp/drivingSchool/DrivingSchoolBusiness';
import DrivingSchoolBusinessPackages from './components/pages/sp/drivingSchool/DrivingSchoolBusinessPackages';
import DrivingSchoolPackages from './components/pages/sp/drivingSchool/DrivingSchoolPackages';
import DrivingSchoolWorkingHours from './components/pages/sp/drivingSchool/DrivingSchoolWorkingHours';
import GaragesBanner from './components/pages/sp/garages/GaragesBanner';
import GaragesBusiness from './components/pages/sp/garages/GaragesBusiness';
import BuyPackages from './components/pages/sp/garages/BuyPackages';
import GaragesServices from './components/pages/sp/garages/GaragesServices';
import GaragesWorkingHours from './components/pages/sp/garages/GaragesWorkingHours';
import QuickServicesBanner from './components/pages/sp/quickServices/QuickServicesBanner';
import QuickServicesBusiness from './components/pages/sp/quickServices/QuickServicesBusiness';
import QuickServicesBusinessPackages from './components/pages/sp/quickServices/QuickServicesBusinessPackages';
import QuickServicesParts from './components/pages/sp/quickServices/QuickServicesParts';
import QuickServicesWorkingHours from './components/pages/sp/quickServices/QuickServicesWorkingHours';
import SpDashboard from './components/pages/sp/SpDashboard';
import Routes from './Routes';
// muqtadir  code here
// rent-cars
import RentCarBanner from './components/pages/sp/rentCar/RentCarBanner';
import RentCarBusiness from './components/pages/sp/rentCar/RentCarBusiness';
import RentCarCars from './components/pages/sp/rentCar/RentCarCars';
import RentCarWorikingHours from './components/pages/sp/rentCar/RentCarWorikingHours';
// car-agents

import CarsAgentsCars from './components/pages/sp/carAgents/CarsAgentsCars';
import CarsAgentsBanner from './components/pages/sp/carAgents/CarsAgentsBanner';
import CarsAgentsBusiness from './components/pages/sp/carAgents/CarsAgentsBusiness';
import CarAgentsBusinessPackages from './components/pages/sp/carAgents/CarsAgentsBusinessPackages';
import CarsAgentsWorkingHours from './components/pages/sp/carAgents/CarsAgentsWorkingHours';
import CarsAgentsWorkshop from './components/pages/sp/carAgents/CarsAgentsWorkshop';
import CarsAgentsShowroom from './components/pages/sp/carAgents/CarsAgentsShowroom';
import CarsAgentsCategories from './components/pages/sp/carAgents/CarsAgentsCategories';
import SparePartsBanner from './components/pages/sp/spareParts/SparePartsBanner';
import SparePartsBusiness from './components/pages/sp/spareParts/SparePartsBusiness';
import SparePartsParts from './components/pages/sp/spareParts/SparePartsParts';
import SparePartsWorkingHours from './components/pages/sp/spareParts/SparePartsWorkingHours';
import SparePartsBusinessPackages from './components/pages/sp/spareParts/SparePartsBusinessPackages';
import TaxiBanner from './components/pages/sp/taxi/TaxiBanner';
import TaxiBusiness from './components/pages/sp/taxi/TaxiBusiness';
import TaxiCars from './components/pages/sp/taxi/TaxiCars';
import CarForSale from './components/pages/sp/carForSale/CarForSale';
import CarForSalePost from './components/pages/sp/carForSale/CarForSalePost';
import TaxiBusinessPackages from './components/pages/sp/taxi/TaxiBusinessPackages';

import TaxiCarsPost from './components/pages/sp/taxi/TaxiCarsPost';
import TaxiWorkingHour from './components/pages/sp/taxi/TaxiWorkingHour';
// import CarsAgentsListings from './components/pages/sp/carAgents/CarsAgentsListings';
import UseGarages from './components/pages/user/garages/UseGarages';
import UserGaragesDetail from './components/pages/user/garages/UserGaragesDetail';
import SpareParts from './components/pages/user/spareParts/SpareParts';
import SparePartShop from './components/pages/user/spareParts/SparePartShop';
import SparePartsShopDetail from './components/pages/user/spareParts/SparePartsShopDetail';
import CarDealersDetails from './components/pages/user/carDealers/CarDealersDetails';
import CarDealersDetailsIn from './components/pages/user/carDealers/CarDealersDetailsIn';
import CarDealers from './components/pages/user/carDealers/CarDealers';
import CarAgents from './components/pages/user/carAgents/CarAgents';
import CarAgentsDetails from './components/pages/user/carAgents/CarAgentsDetails';
import UserTaxi from './components/pages/user/taxi/UserTaxi';
import UserTaxiDetails from './components/pages/user/taxi/UserTaxiDetails';
import RentCar from './components/pages/user/rentCar/RentCar';
import RentCarDetails from './components/pages/user/rentCar/RentCarDetails';
import RentCarDetailsIn from './components/pages/user/rentCar/RentCarDetailsIn';
import Towing from './components/pages/user/userTowing/Towing';
import UserTowingDetails from './components/pages/user/userTowing/UserTowingDetails';
import CarWash from './components/pages/user/carWash/CarWash';
import CarWashDetails from './components/pages/user/carWash/CarWashDetails';
import CarInsurance from './components/pages/user/carInsurance/CarInsurance';
import CarInsuranceDetails from './components/pages/user/carInsurance/CarInsuranceDetails';
import DrivingSchools from './components/pages/user/drivingSchools/DrivingSchools';
import DrivingSchoolDetails from './components/pages/user/drivingSchools/DrivingSchoolDetails';
import CarProtection from './components/pages/user/carProtection/CarProtection';
import CarProtectionDetails from './components/pages/user/carProtection/CarProtectionDetails';
import RentCarbusinessPackages from './components/pages/sp/rentCar/RentCarBusinessPackages';
import AirConditioningDetails from './components/pages/user/airConditioning/AirConditioningDetails';
import AirConditioning from './components/pages/user/airConditioning/AirConditioning';
import QuickServices from './components/pages/user/quickServices/QuickServices';
import QuickServicesDetails from './components/pages/user/quickServices/QuickServicesDetails';
// import CarAgentListingIn from './components/pages/user/carAgents/CarAgentListingDetailIn';
import CarAgentListings from './components/pages/user/carAgents/CarAgentListings';
import CarAgentListingDetailIn from './components/pages/user/carAgents/CarAgentListingDetailIn';
import CarForSaleCars from './components/pages/user/carForSale/CarForSaleCars';
// import CarForSaleCarsToyota from './components/pages/user/carForSale/CarForSaleCarsToyota';
import CarForSaleDetail from './components/pages/user/carForSale/CarForSaleDetail';
import UserCarForSale from './components/pages/user/carForSale/UserCarForSale';
import SettingsEditProfile from './components/settingsPages/SettingsEditProfile';
import RecentlyViewedCar from './components/settingsPages/RecentlyViewedCar';
import SavedItems from './components/settingsPages/SavedItems';
import MyPosts from './components/settingsPages/MyPosts';
import BecomeASeller from './components/settingsPages/BecomeASeller';
import CarTawing from './components/pages/sp/CarTAwing/CarTawing';
import RegisterAs from './components/pages/RegisterAs';
import UserDashboard from './components/pages/user/UserDashboard';
import Header from './components/common/Header';
import ResetPassword from './components/pages/ResetPassword';
import ErrorPage from './components/common/ErrorPage';
import Package from './components/common/Package/Package';
import { useEffect } from 'react';
import GlobalLoader from './components/common/GlobalLoader';
import { useSelector, useDispatch } from 'react-redux';
import { googleLogin } from './Redux/Actions/UserAction';
import Swal from 'sweetalert2';

const App = () => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'en';
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
  }, []);

  // Handle Google OAuth callback globally
  useEffect(() => {
    const handleGoogleCallback = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');

      if (code) {
        console.log('🚀 GOOGLE OAUTH CODE DETECTED:', code);
        
        const googleData = {
          code: code,
          scope: 'openid email profile'
        };

        console.log('🚀 CALLING GOOGLE LOGIN API:', googleData);
        dispatch(googleLogin(googleData));
        
        // Clean up URL
        window.history.replaceState({}, document.title, '/#/login');
      } else if (error) {
        console.error('Google OAuth error:', error);
        Swal.fire({
          title: 'Login Failed',
          text: 'There was an error with Google login. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        
        // Clean up URL
        window.history.replaceState({}, document.title, '/#/login');
      }
    };

    handleGoogleCallback();
  }, [dispatch]);

  const isLoading = useSelector((state) => state.loader.isLoading);

  return (
    <div>
      <GlobalLoader isLoading={isLoading} />
      <Router basename="/">
          {sessionStorage.getItem('loged_In') !== 'true' ? (
            <div>
              <Routes>
                <Route
                  render={({ location }) =>
                    location.pathname !== '/' ? <Header /> : null
                  }
                />
                <Switch>
                  <Route exact path={'/'} component={Home}></Route>
                  <Route exact path={'/login'} component={Login}></Route>
                  <Route exact path={'/login/callback'} component={GoogleCallback}></Route>
                  <Route exact path={'/register'} component={Register}></Route>
                  <Route
                    exact
                    path={'/OtpVerification'}
                    component={OtpVerification}
                  ></Route>
                  <Route
                    exact
                    path={'/reset-password'}
                    component={ResetPassword}
                  ></Route>
                  <Route
                    exact
                    path={'/user-garages'}
                    component={UseGarages}
                  ></Route>
                  <Route
                    exact
                    path={'/user-garages-detail/:garageOwnerId'}
                    component={UserGaragesDetail}
                  ></Route>
                  <Route
                    exact
                    path={'/user-spare-parts'}
                    component={SpareParts}
                  ></Route>
                  <Route
                    exact
                    path={'/user-spare-parts-shop/:partId'}
                    component={SparePartShop}
                  ></Route>

                  <Route
                    exact
                    path={'/user-spare-parts-shop-detail/:productId'}
                    component={SparePartsShopDetail}
                  ></Route>
                  {/* user car dealers */}
                  <Route
                    exact
                    path={'/user-car-dealers'}
                    component={CarDealers}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-dealers-details/:carDealerId'}
                    component={CarDealersDetails}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-dealers-details-in/:carId'}
                    component={CarDealersDetailsIn}
                  ></Route>
                  {/* [CF 2026-08-02] CAR AGENTS RETIRED from the customer site.
                      Every menu link and dashboard tile for it was already
                      commented out, but the routes still rendered the pages for
                      anyone with the URL, so they now bounce to the home page.
                      The components and the /sp-cars-agents-* management routes
                      are left in place: an existing agent owner keeps access to
                      their own business, and restoring the category is just a
                      matter of putting these four routes back. */}
                  <Redirect exact from={'/user-cars-agents'} to={'/'} />
                  <Redirect exact from={'/user-cars-agents-details/:agentDetailId'} to={'/'} />
                  <Redirect exact from={'/user-car-agent-listings'} to={'/'} />
                  <Redirect exact from={'/user-car-agent-listing-details-in'} to={'/'} />
                  {/* User taxi */}
                  <Route exact path={'/user-taxi'} component={UserTaxi}></Route>
                  <Route
                    exact
                    path={'/user-taxi-details/:taxiOwnerId'}
                    component={UserTaxiDetails}
                  ></Route>

                  {/* rent car */}
                  <Route
                    exact
                    path={'/user-rent-car'}
                    component={RentCar}
                  ></Route>

                  <Route
                    exact
                    path={'/user-rent-car-details/:carRentId'}
                    component={RentCarDetails}
                  ></Route>
                  <Route
                    exact
                    path={'/user-rent-car-details-in/:carId'}
                    component={RentCarDetailsIn}
                  ></Route>
                  {/* user towing */}
                  <Route exact path={'/user-towing'} component={Towing}></Route>
                  <Route
                    exact
                    path={'/user-towing-details/:towingOwnerId'}
                    component={UserTowingDetails}
                  ></Route>

                  {/*  user car wash  */}
                  <Route
                    exact
                    path={'/user-car-wash'}
                    component={CarWash}
                  ></Route>

                  <Route
                    exact
                    path={'/user-car-wash-details/:carWashId'}
                    component={CarWashDetails}
                  ></Route>
                  {/*user car insurance */}
                  <Route
                    exact
                    path={'/user-car-insurance'}
                    component={CarInsurance}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-insurance-details/:carInsuranceId'}
                    component={CarInsuranceDetails}
                  ></Route>
                  {/* user driving school */}
                  <Route
                    exact
                    path={'/user-driving-schools'}
                    component={DrivingSchools}
                  ></Route>

                  <Route
                    exact
                    path={'/user-driving-schools-details/:drivingSchoolId'}
                    component={DrivingSchoolDetails}
                  ></Route>
                  {/*user car protection */}
                  <Route
                    exact
                    path={'/user-car-protection'}
                    component={CarProtection}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-protection-details/:carProtectionId'}
                    component={CarProtectionDetails}
                  ></Route>
                  {/* user air conditioning  */}

                  <Route
                    exact
                    path={'/user-air-conditioning'}
                    component={AirConditioning}
                  ></Route>
                  <Route
                    exact
                    path={'/user-air-conditioning-details/:airConditioningId'}
                    component={AirConditioningDetails}
                  ></Route>
                  {/* user quick services */}
                  <Route
                    exact
                    path={'/user-quick-services'}
                    component={QuickServices}
                  ></Route>
                  <Route
                    exact
                    path={'/user-quick-services-details/:quickServiceOwnerId'}
                    component={QuickServicesDetails}
                  ></Route>
                  {/* user	car for sale */}
                  <Route
                    exact
                    path={'/user-cars-for-sale'}
                    component={UserCarForSale}
                  ></Route>
                  <Route
                    exact
                    path={'/user-cars-for-sale-cars/:carBrand'}
                    component={CarForSaleCars}
                  ></Route>
                  {/* <Route
										exact
										path={'/user-cars-for-sale-cars'}
										component={CarForSaleCarsToyota}></Route> */}
                  <Route
                    exact
                    path={'/user-cars-for-sale-detail/:carUUID'}
                    component={CarForSaleDetail}
                  ></Route>
                  <Route path="*" component={ErrorPage} />
                </Switch>
              </Routes>
            </div>
          ) : (
            <div>
              <Routes>
                <Route
                  render={({ location }) =>
                    location.pathname !== '/' ? <Header /> : null
                  }
                />
                <Switch>
                  <Route exact path={'/'} component={Home}></Route>
                  <Route
                    exact
                    path={'/register-as'}
                    component={RegisterAs}
                  ></Route>

                  <Route
                    exact
                    path={'/sp-dashboard'}
                    component={SpDashboard}
                  ></Route>
                  <Route
                    exact
                    path={'/user-dashboard'}
                    component={UserDashboard}
                  ></Route>
                  {/* air-conditioning */}
                  <Route
                    exact
                    path={'/sp-air-conditioning-business'}
                    component={AirConditioningBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-air-conditioning-services'}
                    component={AirConditioningServices}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-air-conditioning-banner'}
                    component={AirConditioningBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-air-conditioning-working-hours'}
                    component={AirConditioningWorkingHours}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-air-conditioning-packages'}
                    component={AirConditioningBusinessPackages}
                  ></Route>
                  {/* car-dealers */}
                  <Route
                    exact
                    path={'/sp-car-dealers-banner'}
                    component={CarDealersBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-dealers-business'}
                    component={CarDealersBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-dealers-cars'}
                    component={CarDealersCars}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-dealers-cars-post'}
                    component={CarDealersCarsPost}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-dealers-working-hours'}
                    component={CarDealersWorkingHours}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-dealers-packages'}
                    component={CarDealersBusinessPackages}
                  ></Route>
                  {/* car-insurance */}
                  <Route
                    exact
                    path={'/sp-car-insurance-business'}
                    component={CarInsuranceBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-insurance-business-packages'}
                    component={CarInsuranceBusinessPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-insurance-packages'}
                    component={CarInsurancePackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-insurance-banner'}
                    component={CarInsuranceBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-insurance-working-hours'}
                    component={CarInsuranceWorkingHours}
                  ></Route>
                  {/* car-protection  */}
                  <Route
                    exact
                    path={'/sp-car-protection-business'}
                    component={CarProtectionBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-protection-business-packages'}
                    component={CarProtectionBusinessPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-protection-packages'}
                    component={CarProtectionPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-protection-banner'}
                    component={CarProtectionBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-protection-working-hours'}
                    component={CarProtectionWorkingHours}
                  ></Route>
                  {/* Car-wash */}
                  <Route
                    exact
                    path={'/sp-car-wash-business'}
                    component={CarWashBusiness}
                  ></Route>
                  {/* car Tawing */}
                  <Route
                    exact
                    path={'/sp-car-towing'}
                    component={CarTawing}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-wash-business-packages'}
                    component={CarWashBusinessPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-wash-packages'}
                    component={CarWashPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-wash-banner'}
                    component={CarWashBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-car-wash-working-hours'}
                    component={CarWashWorkingHours}
                  ></Route>
                  {/* driving */}
                  <Route
                    exact
                    path={'/sp-driving-school-business'}
                    component={DrivingSchoolBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-driving-school-business-packages'}
                    component={DrivingSchoolBusinessPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-driving-school-packages'}
                    component={DrivingSchoolPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-driving-school-banner'}
                    component={DrivingSchoolBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-driving-school-working-hours'}
                    component={DrivingSchoolWorkingHours}
                  ></Route>
                  {/* Garages */}
                  <Route
                    exact
                    path={'/sp-garages-business'}
                    component={GaragesBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-garages-services'}
                    component={GaragesServices}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-garages-banner'}
                    component={GaragesBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-garages-working-hours'}
                    component={GaragesWorkingHours}
                  ></Route>
                  <Route
                    exact
                    path={'/manage-package'}
                    component={BuyPackages}
                  ></Route>

                  {/* quick service  */}
                  <Route
                    exact
                    path={'/sp-quick-services-business'}
                    component={QuickServicesBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-quick-services-parts'}
                    component={QuickServicesParts}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-quick-services-banner'}
                    component={QuickServicesBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-quick-services-working-hours'}
                    component={QuickServicesWorkingHours}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-quick-services-business-packages'}
                    component={QuickServicesBusinessPackages}
                  ></Route>
                  {/* rent-car  */}
                  <Route
                    exact
                    path={'/sp-rent-car-business'}
                    component={RentCarBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-rent-car-banner'}
                    component={RentCarBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-rent-car-cars'}
                    component={RentCarCars}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-rent-car-business-packages'}
                    component={RentCarbusinessPackages}
                  ></Route>

                  <Route
                    exact
                    path={'/sp-rent-car-working-hours'}
                    component={RentCarWorikingHours}
                  ></Route>
                  {/* cares-agents her */}
                  <Route
                    exact
                    path={'/sp-cars-agents-business'}
                    component={CarsAgentsBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-cars-agents-banner'}
                    component={CarsAgentsBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-cars-agents-cars'}
                    component={CarsAgentsCars}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-cars-agents-workshop'}
                    component={CarsAgentsWorkshop}
                  ></Route>

                  <Route
                    exact
                    path={'/sp-cars-agents-working-hours'}
                    component={CarsAgentsWorkingHours}
                  ></Route>

                  <Route
                    exact
                    path={'/sp-cars-agents-categories'}
                    component={CarsAgentsCategories}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-cars-agents-showroom'}
                    component={CarsAgentsShowroom}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-cars-agents-manage-working-hours'}
                    component={CarsAgentsWorkingHours}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-cars-agents-business-packages'}
                    component={CarAgentsBusinessPackages}
                  ></Route>
                  {/* <Route exact path={''} component={CarsAgentsListing}></Route> */}

                  {/* spare parts */}
                  <Route
                    exact
                    path={'/sp-spare-parts-business'}
                    component={SparePartsBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-spare-parts-banner'}
                    component={SparePartsBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-spare-parts-parts'}
                    component={SparePartsParts}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-spare-parts-working-hours'}
                    component={SparePartsWorkingHours}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-spare-parts-business-packages'}
                    component={SparePartsBusinessPackages}
                  ></Route>

                  {/* sp taxi */}
                  <Route
                    exact
                    path={'/sp-taxi-business'}
                    component={TaxiBusiness}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-taxi-car-banner'}
                    component={TaxiBanner}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-taxi-car-cars'}
                    component={TaxiCars}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-taxi-business-packages'}
                    component={TaxiBusinessPackages}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-taxi-car-post'}
                    component={TaxiCarsPost}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-taxi-car-working-hours'}
                    component={TaxiWorkingHour}
                  ></Route>

                  {/* car-for-sale */}
                  <Route
                    exact
                    path={'/sp-cars-for-sale'}
                    component={CarForSale}
                  ></Route>
                  <Route
                    exact
                    path={'/sp-cars-for-sale-post'}
                    component={CarForSalePost}
                  ></Route>

                  {/* user section */}
                  <Route
                    exact
                    path={'/user-garages'}
                    component={UseGarages}
                  ></Route>
                  <Route
                    exact
                    path={'/user-garages-detail/:garageOwnerId'}
                    component={UserGaragesDetail}
                  ></Route>
                  <Route
                    exact
                    path={'/user-spare-parts'}
                    component={SpareParts}
                  ></Route>
                  <Route
                    exact
                    path={'/user-spare-parts-shop/:partId'}
                    component={SparePartShop}
                  ></Route>

                  <Route
                    exact
                    path={'/user-spare-parts-shop-detail/:productId'}
                    component={SparePartsShopDetail}
                  ></Route>
                  {/* user car dealers */}
                  <Route
                    exact
                    path={'/user-car-dealers'}
                    component={CarDealers}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-dealers-details/:carDealerId'}
                    component={CarDealersDetails}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-dealers-details-in/:carId'}
                    component={CarDealersDetailsIn}
                  ></Route>
                  {/* [CF 2026-08-02] CAR AGENTS RETIRED from the customer site.
                      Every menu link and dashboard tile for it was already
                      commented out, but the routes still rendered the pages for
                      anyone with the URL, so they now bounce to the home page.
                      The components and the /sp-cars-agents-* management routes
                      are left in place: an existing agent owner keeps access to
                      their own business, and restoring the category is just a
                      matter of putting these four routes back. */}
                  <Redirect exact from={'/user-cars-agents'} to={'/'} />
                  <Redirect exact from={'/user-cars-agents-details/:agentDetailId'} to={'/'} />
                  <Redirect exact from={'/user-car-agent-listings'} to={'/'} />
                  <Redirect exact from={'/user-car-agent-listing-details-in'} to={'/'} />
                  {/* User taxi */}
                  <Route exact path={'/user-taxi'} component={UserTaxi}></Route>
                  <Route
                    exact
                    path={'/user-taxi-details/:taxiOwnerId'}
                    component={UserTaxiDetails}
                  ></Route>

                  {/* rent car */}
                  <Route
                    exact
                    path={'/user-rent-car'}
                    component={RentCar}
                  ></Route>

                  <Route
                    exact
                    path={'/user-rent-car-details/:carRentId'}
                    component={RentCarDetails}
                  ></Route>
                  <Route
                    exact
                    path={'/user-rent-car-details-in/:carId'}
                    component={RentCarDetailsIn}
                  ></Route>
                  {/* user towing */}
                  <Route exact path={'/user-towing'} component={Towing}></Route>
                  <Route
                    exact
                    path={'/user-towing-details/:towingOwnerId'}
                    component={UserTowingDetails}
                  ></Route>

                  {/*  user car wash  */}
                  <Route
                    exact
                    path={'/user-car-wash'}
                    component={CarWash}
                  ></Route>

                  <Route
                    exact
                    path={'/user-car-wash-details/:carWashId'}
                    component={CarWashDetails}
                  ></Route>
                  {/*user car insurance */}
                  <Route
                    exact
                    path={'/user-car-insurance'}
                    component={CarInsurance}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-insurance-details/:carInsuranceId'}
                    component={CarInsuranceDetails}
                  ></Route>
                  {/* user driving school */}
                  <Route
                    exact
                    path={'/user-driving-schools'}
                    component={DrivingSchools}
                  ></Route>

                  <Route
                    exact
                    path={'/user-driving-schools-details/:drivingSchoolId'}
                    component={DrivingSchoolDetails}
                  ></Route>
                  {/*user car protection */}
                  <Route
                    exact
                    path={'/user-car-protection'}
                    component={CarProtection}
                  ></Route>
                  <Route
                    exact
                    path={'/user-car-protection-details/:carProtectionId'}
                    component={CarProtectionDetails}
                  ></Route>
                  {/* user air conditioning  */}

                  <Route
                    exact
                    path={'/user-air-conditioning'}
                    component={AirConditioning}
                  ></Route>
                  <Route
                    exact
                    path={'/user-air-conditioning-details/:airConditioningId'}
                    component={AirConditioningDetails}
                  ></Route>
                  {/* user quick services */}
                  <Route
                    exact
                    path={'/user-quick-services'}
                    component={QuickServices}
                  ></Route>
                  <Route
                    exact
                    path={'/user-quick-services-details/:quickServiceOwnerId'}
                    component={QuickServicesDetails}
                  ></Route>
                  {/* user	car for sale */}
                  <Route
                    exact
                    path={'/user-cars-for-sale'}
                    component={UserCarForSale}
                  ></Route>
                  <Route
                    exact
                    path={'/user-cars-for-sale-cars/:carBrand'}
                    component={CarForSaleCars}
                  ></Route>
                  {/* <Route
										exact
										path={'/user-cars-for-sale-cars'}
										component={CarForSaleCarsToyota}></Route> */}
                  <Route
                    exact
                    path={'/user-cars-for-sale-detail/:carUUID'}
                    component={CarForSaleDetail}
                  ></Route>
                  {/* Settings pages */}
                  <Route
                    exact
                    path={'/settings-edit-profile'}
                    component={SettingsEditProfile}
                  ></Route>
                  <Route
                    exact
                    path={'/settings-package'}
                    component={Package}
                  ></Route>
                  <Route
                    exact
                    path={'/settings-recently-viewed-cars'}
                    component={RecentlyViewedCar}
                  ></Route>
                  <Route
                    exact
                    path={'/settings-saved-items'}
                    component={SavedItems}
                  ></Route>
                  <Route
                    exact
                    path={'/settings-my-posts'}
                    component={MyPosts}
                  ></Route>
                  <Route
                    exact
                    path={'/settings-become-a-seller'}
                    component={BecomeASeller}
                  ></Route>

                  <Route path="*" component={ErrorPage} />
                </Switch>
                {/* <Route exact path={''} component={}></Route> */}
              </Routes>
            </div>
          )}
      </Router>
    </div>
  );
};

export default withRouter(App);
